import { clsx } from "clsx";
import CloseIcon from "../../icons/close.svg"

function ConfirmAction(props) {
	const style = {
		reason: "m-2",
		button: "py-1 px-4 font-bold text-slate-100 rounded-full cursor-pointer",
	};

	const actionsToDisplayReasons = ['delRtp', 'moveRip'];

	const action = props.actionData.action;
	let confirmMsg = "";
	let confirmBtn = "";
	let confirmBtnStyle = "bg-red-500 hover:bg-red-700";
	let cancelBtnStyle = "bg-zinc-400 hover:bg-zinc-600";
	switch (action) {
		case 'delRtp':
			confirmMsg = "Are you sure you want to delete:";
			confirmBtn = "Delete";
			confirmBtnStyle = "bg-red-500 hover:bg-red-700";
			cancelBtnStyle = "bg-green-500 hover:bg-green-700";
			break;
		case 'moveRip':
			confirmMsg = "Do you want to move this Reason to a Reason-in-Play?";
			confirmBtn = "Begin Bout";
			confirmBtnStyle = "bg-blue-500 hover:bg-blue-700";
			break;
		case 'moveCG':
			confirmMsg = "Do you want to move the Reason-in-Play to Common Ground?";
			confirmBtn = "Common Ground";
			confirmBtnStyle = "bg-green-500 hover:bg-green-700";
			break;
		case 'moveDS':
			confirmMsg = "Do you want to end this bout?";
			confirmBtn = "End Bout";
			break;
		default:
			confirmMsg = "Are you sure you want to perform this action";
			confirmBtn = "Confirm";
	}

	function handleAction() {
		switch (action) {
			case 'delRtp':
				props.deleteReason(props.actionData.data)
				break;
			case 'moveRip':
				props.moveToReasonInPlay(props.actionData.data.playerId, props.actionData.data.reasonId);
				break;
			case 'moveCG':
				props.handleMoveRIPToCommonGround();
				break;
			case 'moveDS':
				props.handleMoveRIPToDissensusList();
				break;
			default:
				confirmMsg = "Are you sure you want to perform this action";
				confirmBtn = "Confirm";
		}
		props.closeModal();
	}

	return (
		<div className="fixed top-1/2 left-1/2 -translate-1/2 h-6/10 w-[95%] lg:h-3/10 lg:w-4/10 p-2 text-center bg-slate-50 border-2 border-blue-400 rounded-lg">
			<div className="absolute top-[10px] right-[10px] p-1 border-2 border-zinc-700 bg-zinc-200 rounded-full cursor-pointer" onClick={props.closeModal}>
				<CloseIcon className="w-[15px]" />
			</div>
			<div className="flex flex-col justify-around h-full">
			<div className="font-bold">{confirmMsg}</div>
				{actionsToDisplayReasons.includes(props.actionData.action) ?
					(
						<>
							<div className={style.reason}>{props.actionData.data.reason}</div>
						</>
					) : null}
				<div className="flex flex-row justify-center gap-8">
					<button aria-label={confirmBtn} className={clsx(style.button, confirmBtnStyle)} onClick={ () => handleAction()}>
						{confirmBtn}
					</button>
					<button aria-label="Cancel" className={clsx(style.button, cancelBtnStyle)} onClick={ () => props.closeModal() }>
						Cancel
					</button>
				</div>
			</div>
		</div>
	);
}

export default ConfirmAction;
